import React from 'react';
import { Pagination } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

interface ISwiperProps {
    items: Array<any>;
    slidesPerView: number;
    spaceBetween: number;
    className?: string;
}

function SwiperComponent({ items, slidesPerView, spaceBetween, className }: ISwiperProps) {
    return (
        <Swiper
            // install Swiper modules
            modules={[Pagination]}
            spaceBetween={spaceBetween}
            slidesPerView={slidesPerView}
            navigation
            pagination={{ clickable: true }}
            className={className}
        >
            {items.map((item) => (
                <SwiperSlide key={item.key}>{item}</SwiperSlide>
            ))}
        </Swiper>
    );
}

export default SwiperComponent;
